import { InlineSVGModule } from 'ng-inline-svg-2';
import { TranslateModule } from '@ngx-translate/core';
import { LeaderboardTrialInvitesInfoComponent } from './leaderboard-trial-invites-info.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [LeaderboardTrialInvitesInfoComponent],
  imports: [CommonModule, InlineSVGModule, TranslateModule],
  exports: [LeaderboardTrialInvitesInfoComponent],
})
export class LeaderboardTrialInvitesInfoModule {}
